import { connect } from 'react-redux';
import { actionExportBookingList, actionGetBookingList } from 'store/booking/actions';
import { GET_MY_PLACE } from 'store/place/actionTypes';
import LocationManagerBooking from './LocationManagerBooking';

const mapStateToProps = (state) => ({
  loadingBookingList: state.Booking.loadingBookingList,
  isLoadingGetMyPlace: state.Place.isLoadingGetMyPlace,
  isLoadingExportBookingList: state.Booking.isLoadingExportBookingList,

  myPlace: state.Place.myPlace,
  bookingList: state.Booking.bookingList,
  bookingTotal: state.Booking.bookingTotal,
});

const mapDispatchToProps = (dispatch) => ({
  actionGetBookingList: (payload) => dispatch(actionGetBookingList(payload)),
  actionExportBookingList: (payload) => dispatch(actionExportBookingList(payload)),

  actionGetMyPlace: (payload) => dispatch({
    type: GET_MY_PLACE,
    payload,
  }),
});

export default connect(mapStateToProps, mapDispatchToProps)(LocationManagerBooking);
